import { FunctionComponent } from 'react';
import { TextField, TextFieldProps } from '@mui/material';
import { FlexContainer } from '@/components/Layout/Container';

export const ColorInput: FunctionComponent<TextFieldProps> = (props) => {
    return (
        <FlexContainer
            sx={{
                alignItems: 'center',
                width: '100%',
            }}
        >
            <TextField
                sx={{
                    display: 'flex',
                    flexGrow: 1,
                }}
                {...props}
            />
            <FlexContainer
                sx={(theme) => ({
                    ml: 2,
                    width: '48px',
                    height: '48px',
                    bgcolor: props.value,
                    border: `1px solid ${theme.palette.grey[200]}`,
                })}
            />
        </FlexContainer>
    );
};
